module.exports = __webpack_public_path__ + "vue/img/upload-03.a76cefd4.png";